export default __webpack_public_path__ + "static/media/List-documentation.ec36b696.md";